/** UI-only guard for Ekspozicija deletes; not secret (visible in client bundle). */
export const EXHIBITION_DELETE_CONFIRM_PASSWORD = 'admin123';
